import { Auth } from "../../types/auth";
import Api from "../api";

export default async function apiGetAuth() {
  return await Api.get<Auth>({
    input: "/api/v1/auth",
  });
}
